import { render, staticRenderFns } from "./IdentityProofingStep.vue?vue&type=template&id=5371d1dc&"
import script from "./IdentityProofingStep.ts?vue&type=script&lang=ts&"
export * from "./IdentityProofingStep.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports